// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  baseUrl: 'https://api.kwikspace.co.za',
  // baseUrl: 'http://localhost:8000',
  floorplanner: {
    apiUrl: "https://floorplanner.com/api/v2/",
    username: '0a6311528a26c176666db4f18507b4ae45123849',
    password: 'x'
  }
};
